export default "__VITE_ASSET__BOzWUwZj__"